module.exports = __webpack_public_path__ + "media/customizations/wolfranchlife/back-695532024fc22482c22270b5fbf8bb77.jpg";